import { createContext } from 'react';

export const GoogleOptimizeContext = createContext<{
  // FIXME(Yuri): Fix type to undefined
  variant: string | null | { isInitialized: boolean; variant: string | null };
}>({
  variant: '',
});
